import i18next from 'i18next';

i18next.addResources('es', 'instinfo', {
  misionTitle: 'Misión',
  mision1: `Promover la integración de las economías de América Latina y el Caribe a través de la realización de proyectos de infraestructura de calidad, eficientes, innovadores y sostenibles.`,
  mision2: 'Promover el desarrollo sostenible a través de proyectos de energía, integración fronteriza, telecomunicaciones, transporte y logística que contribuyan a mejorar la calidad de vida de los habitantes de la región.',
  mision3: 'Apoyar técnica y financieramente programas de integración y desarrollo territorial binacional y/o multinacional, con altos estándares de calidad, innovación, impacto y transparencia.',
  mision4: 'Producir conocimiento y tecnología aplicada a los proyectos de integración.',
  mision5: 'Fomentar la cooperación Sur-Sur y generar espacios de diálogo y apoyo entre los gobiernos, vinculando al sector público y privado.',
  visionTitle: 'Visión',
  visionText: `Ser el principal espacio de trabajo entre organismos multilaterales y países en torno a la infraestructura de integración involucrando la participación de especialistas sectoriales, gobiernos, academia, sector privado y sociedad civil.`,
  valuesTitle: 'Valores',
  valuesText: `Nuestros valores son:`,
  values1: 'Compromiso con la integración y el desarrollo sostenible',
  values2: 'Productividad y calidad',
  values3: 'Inclusión social',
  values4: 'Eficiencia',
  values5: 'Transparencia',
  values6: 'Innovación',
  values7: 'Resiliencia y adaptación',
  values8: 'Diálogo y colaboración',
});

i18next.addResources('en', 'instinfo', {
  misionTitle: 'Mission',
  mision1: `Promote the integration of Latin American and Caribbean economies through quality, efficient, innovative, and sustainable infrastructure projects.`,
  mision2: 'Promote sustainable development through energy, border integration, telecommunications, transportation, and logistics projects that contribute to improving the quality of life of the region\'s inhabitants.',
  mision3: 'Provide technical and financial support to binational and/or multinational territorial integration and development programs, with high standards of quality, innovation, impact, and transparency.',
  mision4: 'Produce knowledge and technology applied to integration projects.',
  mision5: 'Foster South-South cooperation and create spaces for dialogue and support among governments, linking the public and private sectors.',
  visionTitle: 'Vision',
  visionText: `To be the main workspace between multilateral organizations and countries around integration infrastructure involving the participation of sectoral specialists, governments, academia, private sector, and civil society.`,
  valuesTitle: 'Values',
  valuesText: `Our values are:`,
  values1: 'Commitment to integration and sustainable development',
  values2: 'Productivity and quality',
  values3: 'Social inclusion',
  values4: 'Efficiency',
  values5: 'Transparency',
  values6: 'Innovation',
  values7: 'Resilience and adaptation',
  values8: 'Dialogue and collaboration',
});

i18next.addResources('pt', 'instinfo', {
  misionTitle: 'Missão',
  mision1: `Promover a integração das economias da América Latina e Caribe através da realização de projetos de infraestrutura de qualidade, eficientes, inovadores e sustentáveis.`,
  mision2: 'Promover o desenvolvimento sustentável através de projetos de energia, integração fronteiriça, telecomunicações, transporte e logística que contribuam para melhorar a qualidade de vida dos habitantes da região.',
  mision3: 'Apoiar técnica e financeiramente programas de integração e desenvolvimento territorial binacional e/ou multinacional, com altos padrões de qualidade, inovação, impacto e transparência.',
  mision4: 'Produzir conhecimento e tecnologia aplicada aos projetos de integração.',
  mision5: 'Fomentar a cooperação Sul-Sul e gerar espaços de diálogo e apoio entre os governos, vinculando o setor público e privado.',
  visionTitle: 'Visão',
  visionText: `Ser o principal espaço de trabalho entre organismos multilaterais e países em torno da infraestrutura de integração envolvendo a participação de especialistas setoriais, governos, academia, setor privado e sociedade civil.`,
  valuesTitle: 'Valores',
  valuesText: `Nossos valores são:`,
  values1: 'Compromisso com a integração e o desenvolvimento sustentável',
  values2: 'Produtividade e qualidade',
  values3: 'Inclusão social',
  values4: 'Eficiência',
  values5: 'Transparência',
  values6: 'Inovação',
  values7: 'Resiliência e adaptação',
  values8: 'Diálogo e colaboração',
});
